<template>
  <el-cascader
    ref="cascader"
    v-model="val"
    class="kui-cascader"
    :class="`kui-cascader--${elMode}`"
    :style="{
      width: elWidth
    }"
    :size="elSize"
    :disabled="elDisabled"
    :placeholder="_locale(placeholder)"
    :clearable="clearable"
    :show-all-levels="showAllLevels"
    :collapse-tags="collapseTags"
    :separator="separator"
    :filterable="filterable"
    :filter-method="filterMethod"
    :debounce="debounce"
    :before-filter="beforeFilter"
    :popper-class="popperClass"
    v-bind="$attrs"
    :options="_options"
    :props="props"
    @remove-tag="(val) => $emit('remove-tag', val)"
    @visible-change="(flag) => $emit('visible-change', flag)"
    @blur="handleBlur"
    @focus="handleFocus"
    @change="(val) => $emit('select-change', val)"
    @expand-change="(data) => $emit('expand-change', data)"
  >
    <template slot-scope="scope">
      <slot v-bind="scope"></slot>
    </template>

    <template #empty>
      <slot name="empty"></slot>
    </template>
  </el-cascader>
</template>
<script>
import formMixin from './formMixin'
export default {
  name: 'SuiCascader',
  mixins: [formMixin],
  props: {
    opts: {
      type: Array
      // required: true
    },
    options: {
      type: Array
      // required: true
    },
    clearable: {
      type: Boolean
    },
    // 输入框中是否显示选中值的完整路径
    showAllLevels: {
      type: Boolean,
      default: true
    },
    // 多选模式下是否折叠Tag
    collapseTags: {
      type: Boolean,
      default: false
    },
    // 选项分隔符
    separator: {
      type: String,
      default: '/'
    },
    filterable: {
      type: Boolean
    },
    filterMethod: {
      type: Function,
      default: null
    },
    // 搜索关键词输入的去抖延迟，毫秒
    debounce: {
      type: Number,
      default: 300
    },
    // 筛选之前的钩子，参数为输入的值，若返回 false 或者返回 Promise 且被 reject，则停止筛选
    beforeFilter: {
      type: Function
    },
    popperClass: {
      type: String,
      default: ''
    },
    expandTrigger: {
      type: String,
      default: 'click',
      validator(value) {
        return ['click', 'hover'].indexOf(value) !== -1
      }
    },
    multiple: {
      type: Boolean
    },
    // 是否严格的遵守父子节点不互相关联
    checkStrictly: {
      type: Boolean
    },
    // 在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
    emitPath: {
      type: Boolean,
      default: true
    },
    lazy: {
      type: Boolean
    },
    lazyLoad: {
      type: Function,
      default: null
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    childrenKey: {
      type: String,
      default: 'children'
    },
    disabledKey: {
      type: String,
      default: 'disabled'
    },
    isLeafKey: {
      type: String,
      default: 'leaf'
    },
    leafKey: {
      type: String,
      default: ''
      // default: "leaf"
    },
    isMultipleStringValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      remoteOptions: null
    }
  },
  computed: {
    val: {
      get() {
        if (this.prop && this.SuiForm) {
          return this.SuiForm.model[this.prop]
        } else {
          return this.value
        }
      },
      set(val) {
        if (this.prop && this.SuiForm) {
          if (this.multiple && this.isMultipleStringValue && typeof val === 'string') {
            val = val.split(',')
            val = val.map((value) => {
              return Number(value) || value
            })
          }
          this.SuiForm.model[this.prop] = val
        } else {
          if (this.multiple && this.isMultipleStringValue && typeof val === 'string') {
            val = val.split(',')
            val = val.map((value) => {
              return Number(value) || value
            })
          }
          this.$emit('input', val)
        }
      }
    },
    _options() {
      return this.options || this.opts || this.remoteOptions
    },
    props() {
      return {
        expandTrigger: this.expandTrigger,
        multiple: this.multiple,
        checkStrictly: this.checkStrictly,
        emitPath: this.emitPath,
        lazy: this.lazy,
        lazyLoad: this.lazyLoad,
        value: this.valueKey,
        label: this.labelKey,
        children: this.childrenKey,
        disabled: this.disabledKey,
        leaf: this.leafKey || this.isLeafKey
      }
    }
  },
  created() {
    if (!Array.isArray(this.val)) {
      if (!this.isMultipleStringValue) {
        this.val = this.val === '' ? [] : [this.val]
      } else {
        this.val = this.val === '' ? '' : this.val
      }
    }
  },
  methods: {
    getCheckedNodes(leafOnly) {
      return this.$refs.cascader.getCheckedNodes(leafOnly)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/form/SuiCascader.vue